/**
 * Walker to traverse the Plugin Definition AST defined by the PluginDefinition Type in Types.ts
 *
 * This class is used to decouple the traversing strategy from the AST, so the AST is only a data structure without any methods.
 * If there is need for another traversing strategy, wen can implement another Walker.
 *
 * The Walker is part of the Visitor Pattern.
 *
 * @public
 */
export class DefaultWalker {
    walk(ast, visitor) {
        ast.forEach(pd => {
            this.walkPluginDefinition(pd, visitor);
        });
    }
    walkPluginDefinition(pd, visitor) {
        visitor.visitPluginDefinition(pd);
        if ("group" in pd) {
            this.walkPluginGroup(pd, visitor);
        }
        else {
            this.walkPlugin(pd, visitor);
        }
    }
    walkPluginGroup(pluginGroup, visitor) {
        visitor.visitGroupStart(pluginGroup);
        if (pluginGroup.group.length >= 1) {
            this.walkPlugin(pluginGroup.group[0], visitor);
            for (let i = 1; i < pluginGroup.group.length; i += 1) {
                visitor.visitGroupNext(pluginGroup, pluginGroup.group[i - 1], pluginGroup.group[i]);
                this.walkPlugin(pluginGroup.group[i], visitor);
            }
        }
        visitor.visitGroupEnd(pluginGroup);
        if (pluginGroup.merge) {
            visitor.visitMerge(pluginGroup.merge);
            this.walkPlugin(pluginGroup.merge, visitor);
        }
    }
    walkPlugin(plugin, visitor) {
        visitor.visitPlugin(plugin);
        // piped plugin
        if (plugin.piped.length === 1) {
            visitor.visitPipe(plugin, plugin.piped[0]);
            this.walkPlugin(plugin.piped[0], visitor);
        }
        // split
        if (plugin.piped.length >= 2) {
            visitor.visitSplitStart(plugin.piped, plugin);
            this.walkPlugin(plugin.piped[0], visitor);
            for (let i = 1; i < plugin.piped.length; i += 1) {
                visitor.visitSplitNext(plugin.piped, plugin.piped[i - 1], plugin.piped[i], plugin);
                this.walkPlugin(plugin.piped[i], visitor);
            }
            visitor.visitSplitEnd(plugin.piped, plugin);
        }
        // merge ?
        if (plugin.merge) {
            visitor.visitMerge(plugin.merge);
            this.walkPlugin(plugin.merge, visitor);
        }
    }
}
//# sourceMappingURL=DefaultWalker.js.map